<template>
  <div class="order-progress clearfix">
    <div v-for="(item,index) in tracks" :key="index" v-show="index==0 || showMore">
      <div class="time-content">
        <p class="date">{{item.timeDesc}}</p>
        <!-- <p class="time">08:09</p> -->
      </div>
      <div class="progress-content">
        <ul>
          <li class="clearfix">
            <em></em>
            <i></i>
            <p v-html="item.desc"></p>
          </li>
        </ul>
      </div>
    </div>
    <template v-if="tracks&&tracks.length>1">
      <div @click="showMore = !showMore" v-if="!showMore" class="show-btn">展开全部进展<van-icon name="arrow-down" /></div>
      <div @click="showMore = !showMore" v-if="showMore" class="show-btn">收起全部进展<van-icon name="arrow-up" /></div>
    </template>
  </div>
</template>
<style scoped lang="scss">
  .order-progress{
    margin-top: 10px;
    padding: 0 15px;
    overflow: hidden;
    .show-btn{
      margin: 0px 0 0px 97px;
      color: #22BAA5;
      font-size: 14px;
      border-left: solid 1px #ddd;
      padding: 5px 0 15px 15px;
      .van-icon{
        margin: 0 0 0 5px;
        vertical-align: text-top;
      }
    }
    .time-content{
      width: 80px;
      float: left;
      text-align: right;
      .date{
        font-size: 12px;
        color: #333;
        margin-bottom: 10px;
      }
      .time{
        font-size: 10px;
        color: #333;
      }
    }
    .progress-content{
      margin-left: 90px;
      overflow: hidden;
      >ul {
        background-color: #fff;
        padding: 0 0 0 7px;
        > li {
          padding: 2px 0 10px 15px;
          position: relative;
          line-height: 24px;
          color: #333;
          font-size: 14px;
          em {
            position: absolute;
            width: 1px;
            height: 100%;
            background: #ddd;
            top: 8px;
            left: 0;
          }
          &:first-child {
            margin-top: -3px;
            i {
              background: url('../../assets/blue-line-dot.png') center center no-repeat;
              left: -6px;
              top: 6px;
              background-size: cover;
            }
            em {
              top: 8px;
            }
          }
          &:last-child {
            border-left: none;
          }
          > i {
            left: -6px;
            position: absolute;
            background: url('../../assets/gray-line-dot.png') center center no-repeat;
            width: 13px;
            height: 13px;
            display: inline-block;
            top: 6px;
            background-size: cover;
          }
        }
      }
    }
  }
</style>
<script>
export default {
  props: {
    tracks: {
      default: []
    }
  },
  data(){
    return{
      showMore: false
    };
  },
  components: {
    
  },
  methods: {
  },
  created() {
  }
};
</script>
